module.exports = __webpack_public_path__ + "static/media/2DGACM11.dba4d6c2.jpg";